import React from 'react'
import { Spin, Card } from 'antd'
import { observer } from 'mobx-react-lite'

export const Loading: React.FC = observer((props) => {
	return (
		<div
			className={`d-flex justify-content-center align-items-center`}
			style={{
				zIndex: 9,
				position: `absolute`,
				top: 0,
				left: 0,
				width: `100%`,
				height: `100%`,
				backdropFilter: `blur(3px)`
			}}
		>
			<Card style={{ height: `fit-content` }}	>
				<Spin
					size={`large`}
					style={{ margin: `auto` }}
				/>
			</Card>
		</div>
	)
})